module.exports = __webpack_public_path__ + "img/top10.9b50251f.png";